<template>
    <div class="motifs step">
        <div>
            <div class="step-static">
                <div class="step-content">
                    <div class="search-area">
                        <ProductSelections v-on="$listeners" />
                        <div class="search-form">
                            <div>
                                <label>Search Motifs</label>
                                <div id="motifSearch">
                                    <input type="text" ref="searchInput" v-model="searchQuery" placeholder="Enter keywords..." />
                                    <a class="delete" @click="clearQuery ">&#10005;</a>
                                </div>
                            </div>
                            <div>
                                <label>Browse Motifs</label>
                                <select id="motifCategorySelect"
                                        v-on:change="onMotifCategoryChange($event)">
                                    <option value="0">Go to category..</option>
                                    <option value="0" v-if="searchQuery.length > 2">
                                        Search Results
                                    </option>
                                    <option v-for="mc in motifCatList"
                                            v-bind:value="mc.categoryId"
                                            :key="mc.categoryId">
                                        {{ mc.categoryName }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="scroll" class="step-scroll">
                <div class="step-content">
                    <div class="motif-categories">
                        <div class="motif-category-area" v-if="searchQuery.length > 2">
                            <h2>Search Results : {{ searchQuery }}</h2>
                            <div class="motif-category"
                                 :list="filteredMotifs"
                                 :group="{ name: 'ProductMotifs', pull: 'clone', put: false }"
                                 :sort="false"
                                 :clone="onClone"
                                 @start="drag = true"
                                 @end="drag = false">
                                <transition-group tag="div" class="category-motifs" v-if="filteredMotifs.length>0">
                                    <div class="category-motif"
                                         v-for="m in filteredMotifs"
                                         :key="m">
                                        <Motif :m="motifList[m]"
                                               v-on:click.native="addMotif(motifList[m])" />
                                    </div>
                                </transition-group>
                                <div v-else>No motifs found that match "{{ searchQuery }}"</div>
                            </div>
                        </div>
                        <div class="motif-category-area removable" v-if="designMotifList.length > 0">
                            <h2>Your Motifs</h2>
                            <div class="motif-category"
                                 :list="designMotifList"
                                 :group="{ name: 'ProductMotifs', pull: 'clone', put: false }"
                                 :sort="false"
                                 :clone="onClone"
                                 @start="drag = true"
                                 @end="drag = false">
                                <transition-group tag="div" class="category-motifs" >
                                    <div class="category-motif"
                                         v-for="m in designMotifList"
                                         :key="m">

                                        <div class="remove" v-on:click="removeMotifFromDesignList(m)" title="Remove from your motifs list"></div>
                                        <Motif :m="motifList[m]"
                                               v-on:click.native="addMotif(motifList[m])" />
                                    </div>
                                </transition-group>
                            </div>
                        </div>
                        <div class="motif-category-area"
                             v-for="mc in motifCatList"
                             :key="mc.categoryId"
                             :data-id="mc.categoryId">
                            <h2>{{ mc.categoryName }}</h2>

                            <div class="motif-category"
                                 :list="mc.motifIndexes"
                                 :group="{ name: 'ProductMotifs', pull: 'clone', put: false }"
                                 :sort="false"
                                 :clone="onClone"
                                 @start="drag = true"
                                 @end="drag = false">
                                <transition-group tag="div"
                                                  class="category-motifs"
                                                  :key="mc.categoryId">
                                    <div class="category-motif"
                                         v-for="m in mc.motifIndexes"
                                         :key="m">
                                        <Motif :m="motifList[m]"
                                               v-on:click.native="addMotif(motifList[m])" />
                                    </div>
                                </transition-group>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style>
    .step.motifs {
    }

    .motif-categories {
        min-height: 1000px;
    }

        .motif-categories h2 {
            color: #288b7a;
            font-size: 1.1em;
            text-transform: uppercase;
            font-weight: normal;
            text-align: left;
            line-height: 1.5em;
            padding: 0 0.5em;
            border-radius: 1px;
            margin: 0 0 1em;
            border-bottom: solid 1px;
        }

    .motif-category {
        margin: 0.5em 0 1.5em;
    }

    .category-motif {
        display: inline-block;
    }

        .category-motif .motif {
            display: inline-block;
            margin: 0.75em;
        }

    .removable .category-motif {
        padding-top: .4em;
        margin-top: -.4em;
    }

        .category-motif .remove {
            position: absolute;
            opacity: 0;
            cursor: pointer;
            color: #ccc;
            width: 100%;
            height: 1.2em;
            line-height: 1.2em;
            font-weight: bold;
            left: 50%;
            transform: translate(-50%, -.8em);
        }

        .category-motif:hover .remove {
            opacity: 1;
            transition: opacity .5s 2s;
        }

        .category-motif .remove::before {
            left: calc(50% - 0.6em);
            width: 1.2rem;
            height: 1.2rem;
            line-height: 1.2rem;
            font-size: 0.8em;
            border-radius: 100%;
            content: "\2716";
            display: inline-block;
        }

        .category-motif .remove:hover::before {
            background: #ccc;
            color: #fff;
        }

    .category-motif {
        position: relative;
        display: flex;
        justify-content: center;
    }

    .category-motifs {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
    }

    .category-motif .remove::before {
        content: '\2716';
    }
    .key-fob .category-motif .motif[data-wide="1"] {
        display: none;
    }

        .category-motif img {
            height: 2em;
            image-rendering: pixelated;
            filter: drop-shadow(1px 1px 1px #666);
        }

        .category-motif:hover img {
            filter: brightness(110%) drop-shadow(1px 1px 1px #666);
            transform: scale(1.05);
            cursor: pointer;
        }

    .custom-motif {
    }

    .motif-category-area {
    }

    .search-area {
        display: flex;
        column-gap: 1em;
        justify-content: center;
        row-gap: 1em;
        margin:1em;

    }

    @media only screen and (max-width: 550px) {
        .search-area {
            flex-wrap: wrap;
        }
    }

        .search-area > div {
            flex: 1 1 auto;
        }

    .search-form {
        display: flex;
        -moz-column-gap: 1em;
        column-gap: 1em;
        justify-content: center;
        row-gap: 1em;
        flex: 1 1 auto;
    }

        .search-form > div {
            width: 50%;
        }

    select#motifCategorySelect {
        border: solid 1px #ccc;
        height: calc(2em + 4px);
        font-size: 1em;
        width: 100%;
        background: #fff;
        border-radius: 2px;
        color: #666;
    }

    #motifSearch {
        position: relative;
    }

        #motifSearch input {
            border: solid 1px #ccc;
            height: calc(2em + 4px);
            font-size: 1em;
            width: 100%;
            background: #fff;
            border-radius: 2px;
        }

            #motifSearch input::placeholder {
                color: #666;
                opacity: 1;
            }

            #motifSearch input:focus::placeholder {
                opacity: 0.3;
            }

        #motifSearch a {
            display: none;
        }

        #motifSearch:hover input:not(:placeholder-shown) ~ a {
            position: absolute;
            line-height: 1.25em;
            right: 0.5em;
            background: #ccc;
            color: #fff;
            display: inline-block;
            margin: calc(0.5em) 0;
            border-radius: 100%;
            width: 1.25em;
            bottom: 0;
            cursor: pointer;
            z-index: 5;
        }

    .search-area label {
        font-size: 0.75em;
        text-transform: uppercase;
        line-height: 1.25rem;
    }
</style>

<script>
    import ProductMotif from "@/objects/ProductMotif.js";
    import Globals from "@/globals.js";
    import ProductSelections from "@/components/ProductSelections.vue";

    import Motif from "@/components/Motif.vue";
    //import draggable from "vuedraggable";
    import { mapState } from "vuex";

    export default {
        name: "Motifs",
        components: {
            Motif,
            //draggable,
            ProductSelections,
        },
        computed: {
            ...mapState(["motifList", "motifCatList", "productMotifs", "userProduct"]),
            filteredMotifs: function () {
                let items = this.motifList;
                var result = [];
                if (this.searchQuery.length > 2) {
                    Object.keys(items).forEach((key) => {
                        const item = items[key];
                        let searchFields = item.motifName + " " + item.motifTags;
                        if (
                            searchFields.toLowerCase().includes(this.searchQuery.toLowerCase())
                        ) {
                            result.push(item.motifIndex);
                        }
                    });

                    let c = document.querySelector(".step-scroll");
                    c.scroll({ top: 0, behavior: "smooth" });
                }

                return result;
            },
        },
        data: function () {
            return {
                customizingMotif: null,
                searchQuery: "",
                designMotifList: [],
            };
        },
        methods: {
            onClone(motifIndex) {
                let motif = this.$store.state.motifList[motifIndex];
                if (motif.motifType == 1) {
                    if (this.checkWidth(motif)) {
                        let pmId = Globals.getUniquePMId(this.$store.state.productMotifs);
                        let pm = new ProductMotif(motif, null, pmId);
                        return pm;
                    }
                } else this.$emit("open-custom-motif", motif);
            },
            addMotif(motif) {
                if (!this.designMotifList.includes(motif.motifIndex))
                        this.designMotifList.push(motif.motifIndex);
                if (motif.motifType == 1) {
                    if (this.checkWidth(motif)) 
                        this.$store.dispatch("addMotifToProduct", motif);

                } else {
                    this.$emit("open-custom-motif", motif);
                }
            },//removeMotifFromDesignList
            removeMotifFromDesignList(mIndex) {

                const index = this.designMotifList.indexOf(mIndex);

                this.designMotifList.splice(index, 1);
            },
            checkWidth(motif) {
                let hasSpace = Globals.checkWidth(this.$store, null, motif);
                if (hasSpace) {
                    return true;
                } else {
                    this.$emit("alert-width", motif);
                    return false;
                }
            },
            initDesignMotifs() {
                let items = this.$store.state.productMotifs;
                Object.keys(items).forEach((key) => {
                    const item = items[key];
                    if (!this.designMotifList.includes(item.motifData.motifIndex))
                        this.designMotifList.push(item.motifData.motifIndex);
                });
               
            },
            scrollToMotifCategory(catId) {
                let topPos = 0;
                let c = document.querySelector(".step-scroll");
                if (catId != 0) {
                    let e = document.querySelector(
                        '.motif-category-area[data-id="' + catId + '"]'
                    );
                    topPos = e.offsetTop - c.offsetTop;
                }

                c.scroll({ top: topPos, behavior: "smooth" });
            },
            onMotifCategoryChange(event) {
                this.scrollToMotifCategory(event.target.value);
            },
            clearQuery() {
                this.$refs.searchInput.focus();
                this.searchQuery = '';
            }
        },
        mounted: function () {
            this.initDesignMotifs();
        },
    };
</script>
